import { NodeSource, TreeAdapter, TreeOptions, TreeSource } from "@omegagrid/tree";
import { getLocale, msg } from "@omegagrid/localize";
import rp from '@reporting/rp-app-host';
import { HistoryTable } from '@reporting/rp-types/server';

const DB_TYPES: string[] = ['master', 'super'];

/** Label of a history table: the translated name with the table name for those who know the database */
export const historyTableLabel = (table: HistoryTable) => `${msg(table.name)} (${table.table})`;

/** Tables with a change history (/history/tables) grouped by their database, the key is the table name */
export class HistoryTableTreeAdapter extends TreeAdapter {

	private items: NodeSource[];

	constructor(
		private options?: Partial<TreeOptions>,
	) { super() }

	async getTree(): Promise<TreeSource> {
		if (this.items) return this.items;
		this.items = [];
		const tables = await rp.ms('server').get<HistoryTable[]>('history/tables');
		for (const dbType of DB_TYPES) {
			this.items.push({
				l: 0,
				k: dbType,
				v: msg(dbType),
				collapsed: true,
				ch: false,
				folder: { openIcon: 'folder-open', closedIcon: 'folder-closed' }
			});
			// alphabetically by the translated label, in the language of the application
			this.items.push(...tables
				.filter(t => t.db_type === dbType)
				.map<NodeSource>(t => ({ l: 1, k: t.table, v: historyTableLabel(t) }))
				.sort((a, b) => a.v.localeCompare(b.v, getLocale())));
		}
		return this.items;
	}

	getOptions(): Partial<TreeOptions> {
		return this.options || {};
	}
}
